<template>
  <div>
    <div class="bg-white overflow-hidden">
      <!--  START HEADER LANDING PAGE -->
      <div class="invoiceHeaderDiv pt-5 pr-5 pl-5 lg:pl-20 lg:pr-20">
        <div>
          <div class="invoice-header flex justify-between items-center w-full">
            <div>
              <img src="../../assets/images/logo/bp-logo.png" width="150" />
            </div>
            <div class="hidden lg:block">
              <div class="flex justify-between">
                <div v-for="bloco in blocosLandingPage" :key="bloco.divDestino">
                  <div
                    class="px-10 py-4 cursor-pointer"
                    @click="scrollBloco(bloco.divDestino)"
                    :class="{ bordaAzul: divAtiva === bloco.divDestino }"
                    :ref="bloco.divDestino"
                  >
                    <span>{{ bloco.nome }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="!modalNovaProposta && cepPreenchido == true"
              class="div-button"
              @click="modalNovaProposta = true"
            >
              <div
                class="botaoContratarAgora flex gap-2"
                @click="modalNovaProposta = true"
              >
                <span>Gerar proposta</span>
                <img
                  src="../../assets/images/svg/iconArrowRight.svg"
                  alt="Ícone seta para a direita."
                />
              </div>
            </div>
            <div v-else class="div-button">
              <div class="flex gap-2 textoAmbienteSeguro items-center">
                <img
                  src="../../assets/images/svg/iconLock.svg"
                  alt="Ícone Cadeado."
                />
                <span>Ambiente Seguro</span>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>

      <formCep
        v-if="cepPreenchido == false"
        @cepSalvo="cepPreenchido = true"
      ></formCep>

      <!--  END HEADER LANDING PAGE -->
      <div v-if="!modalNovaProposta" class="counteudo-landing">
        <!--  START LANDING PAGE PRIMEIRO BLOCO INFOS -->
        <div class="bgAzulSuperiorLg pt-20" ref="blocoInicial">
          <div class="container">
            <div class="mt-10">
              <div
                class="cardAzul p-5 lg:p-0 mt-5 flex lg:justify-center lg:items-center lg:pb-0"
              >
                <div class="w-2/3 lg:w-1/2">
                  <div class="pb-5">
                    <span class="tituloPrimeiroCardAzul"
                      >Na bem protege é assim, você fica <br />
                      tranquilo e seu veículo seguro.<br />
                      Cobertura completa a partir de
                    </span>
                    <div class="">
                      <span class="tituloPrimeiroCardAzul2 text-2xl lg:text-4xl"
                        >R$1,96 ao dia.</span
                      >
                    </div>
                  </div>
                  <div class="flex items-center gap-3 pb-2">
                    <div>
                      <img
                        src="../../assets/images/svg/iconAtom1.svg"
                        alt="Ícone Átomo"
                      />
                    </div>
                    <div>
                      <span class="conteudoPrimeiroCardAzul text-base"
                        >Cobertura em <b>todo o território</b> nacional
                        <b>24 horas</b> por dia.</span
                      >
                    </div>
                  </div>
                  <!-- <div class="flex items-center gap-3 pb-2">
                    <div class="iconesDivReclameAqui">
                      <div>
                        <img
                          src="../../assets/images/svg/iconHappy1.svg"
                          alt="Ícone Rosto Alegre."
                        />
                      </div>
                      <div class="iconeReclameAqui">
                        <img
                          src="../../assets/images/svg/iconReclameAquiNota.svg"
                          alt="Ícone nota reclame aqui."
                        />
                      </div>
                    </div>
                    <div>
                      <span class="conteudoPrimeiroCardAzul text-base"
                        >Nota mais alta de avaliações no
                        <b>Reclame Aqui!</b></span
                      >
                    </div>
                  </div> -->
                  <div class="flex items-center gap-3 pb-2">
                    <div>
                      <img
                        src="../../assets/images/svg/iconSecurity1.svg"
                        alt="Ícone Escudo"
                      />
                    </div>
                    <div>
                      <span class="conteudoPrimeiroCardAzul text-base"
                        >Referência no setor de <b>segurança veicular</b></span
                      >
                    </div>
                  </div>
                </div>
                <div class="fotoGustavoLimaDiv relative w-1/3 lg:hidden">
                  <img
                    src="../../assets/images/fotos-gustavo-lima/gustavo-lima.png"
                    alt="Gustavo Lima."
                    class="fotoGustavoLima absolute"
                  />
                </div>
                <div>
                  <img
                    src="../../assets/images/fotos-gustavo-lima/gustavo-lima-lg.png"
                    alt="Gustavo Lima."
                    class="hidden lg:block fotoGustavoLimaLg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  END LANDING PAGE PRIMEIRO BLOCO INFOS -->
        <!--  START LANDING PAGE BLOCO SWIPPER TIPOS DE PROTEÇÃO -->
        <div class="container">
          <div class="swipperServicos pb-5 pt-5">
            <swiper :options="swiperOption" class="p-5 lg:p-10">
              <swiper-slide>
                <div class="cardSwiper p-5 m-5">
                  <div class="flex justify-start items-center gap-4">
                    <div>
                      <img
                        src="../../assets/images/elements/blobCar.png"
                        alt="Carro miniatura foto."
                      />
                    </div>
                    <div>
                      <div class="titleSwipper text-base">
                        <span>Bem protege</span>
                      </div>
                      <div class="subtitleSwipper"><span>Carro</span></div>
                    </div>
                  </div>
                  <div class="pt-5">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Carros de passeio</span
                    >
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Carros de leilão</span
                    >
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Carros de aplicativo e mais!</span
                    >
                  </div>
                  <div
                    class="flex justify-between p-5 mt-5 ml-3 cursor-pointer"
                    @click="modalNovaProposta = true"
                  >
                    <div class="textoContratarAgoraSwiper">
                      <span>Gerar proposta</span>
                    </div>
                    <div>
                      <img
                        src="../../assets/images/svg/arrowRightCards.svg"
                        alt="Seta para a direita."
                      />
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardSwiper p-5 m-5">
                  <div class="flex justify-start items-center gap-4">
                    <div>
                      <img
                        src="../../assets/images/elements/blobByke.png"
                        alt="Carro miniatura foto."
                      />
                    </div>
                    <div>
                      <div class="titleSwipper text-base">
                        <span>Bem protege</span>
                      </div>
                      <div class="subtitleSwipper"><span>Motos</span></div>
                    </div>
                  </div>
                  <div class="pt-5">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Todas as cilindradas</span
                    >
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Motos de aplicativo</span
                    >
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Motos de delivery e mais!</span
                    >
                  </div>
                  <div
                    class="flex justify-between p-5 mt-5 ml-3 cursor-pointer"
                    @click="modalNovaProposta = true"
                  >
                    <div class="textoContratarAgoraSwiper">
                      <span>Gerar proposta</span>
                    </div>
                    <div>
                      <img
                        src="../../assets/images/svg/arrowRightCards.svg"
                        alt="Seta para a direita."
                      />
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardSwiper p-5 m-5">
                  <div class="flex justify-start items-center gap-4">
                    <div>
                      <img
                        src="../../assets/images/elements/blobUtilitiesVecicles.png"
                        alt="Carro miniatura foto."
                      />
                    </div>
                    <div>
                      <div class="titleSwipper text-base">
                        <span>Bem protege</span>
                      </div>
                      <div class="subtitleSwipper">
                        <span>Utilitários</span>
                      </div>
                    </div>
                  </div>
                  <div class="pt-5">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base">SUV</span>
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Caminhonetes</span
                    >
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Vans de carga e Mais!</span
                    >
                  </div>
                  <div
                    class="flex justify-between p-5 mt-5 ml-3 cursor-pointer"
                    @click="modalNovaProposta = true"
                  >
                    <div class="textoContratarAgoraSwiper">
                      <span>Gerar proposta</span>
                    </div>
                    <div>
                      <img
                        src="../../assets/images/svg/arrowRightCards.svg"
                        alt="Seta para a direita."
                      />
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="cardSwiper p-5 m-5">
                  <div class="flex justify-start items-center gap-4">
                    <div>
                      <img
                        src="../../assets/images/elements/blobTruck.png"
                        alt="Carro miniatura foto."
                      />
                    </div>
                    <div>
                      <div class="titleSwipper text-base">
                        <span>Bem protege</span>
                      </div>
                      <div class="subtitleSwipper"><span>Caminhões</span></div>
                    </div>
                  </div>
                  <div class="pt-5">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Agregados</span
                    >
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Implementos e mais!</span
                    >
                  </div>
                  <div class="pt-1">
                    <img
                      src="../../assets/images/svg/iconChecked1.svg"
                      alt="ícone check."
                    />
                    <span class="ml-4 detalhesCardSwiper text-base"
                      >Vans de carga e Mais!</span
                    >
                  </div>
                  <div
                    class="flex justify-between p-5 mt-5 ml-3 cursor-pointer"
                    @click="modalNovaProposta = true"
                  >
                    <div class="textoContratarAgoraSwiper">
                      <span>Gerar proposta</span>
                    </div>
                    <div>
                      <img
                        src="../../assets/images/svg/arrowRightCards.svg"
                        alt="Seta para a direita."
                      />
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <!--  END LANDING PAGE BLOCO SWIPPER TIPOS DE PROTEÇÃO -->

          <div class="subTitulosMeio pt-5" ref="blocoBeneficios">
            <!-- <div class="principaisBeneficios text-base">
              <span>Principais Benefícios</span>
            </div> -->
            <div class="protecaoCompleta">
              <span>Principais Benefícios</span>
            </div>
          </div>
          <!--  START LANDING PAGE BLOCO COLLAPSE BENEFÍCIOS -->
          <div class="lg:pl-20 lg:pr-20">
            <vs-collapse>
              <vs-collapse-item>
                <div slot="header" class="flex items-center gap-2 pl-0">
                  <div class="collapseIconBackGround pt-2 pr-2 pl-2">
                    <img
                      src="../../assets/images/svg/iconSlipperyRoad1.svg"
                      alt="Ícone Furto e Roubo"
                    />
                  </div>
                  <span>Furto e roubo</span>
                </div>
                Com a Bem Protege, você pode se sentir seguro e protegido em
                qualquer lugar, a qualquer momento
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header" class="flex items-center gap-2 pl-0">
                  <div class="collapseIconBackGround pt-2 pr-2 pl-2">
                    <img
                      src="../../assets/images/svg/iconTowedCar1.svg"
                      alt="Ícone Guincho"
                    />
                  </div>
                  <span>Guincho ilimitado</span>
                </div>
                Você pode ter um serviço de até 1000km (somando a ida com a
                volta) em todo o território nacional
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header" class="flex items-center gap-2 pl-0">
                  <div class="collapseIconBackGround pt-2 pr-2 pl-2">
                    <img
                      src="../../assets/images/svg/iconCarInsurance1.svg"
                      alt="Ícone Assistência 24 horas"
                    />
                  </div>
                  <span>Assistência 24 horas</span>
                </div>
                Nossa equipe conta com especialistas para atender você 24 horas
                por dia
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header" class="flex items-center gap-2 pl-0">
                  <div class="collapseIconBackGround pt-2 pr-2 pl-3">
                    <img
                      src="../../assets/images/svg/iconProblemElectric1.svg"
                      alt="Ícone cobertura para terceiros"
                    />
                  </div>
                  <span
                    >Colisão/cobertura para terceiros <b>até 100mil</b></span
                  >
                </div>
                Com a nossa cobertura, você pode proteger o seu bolso
              </vs-collapse-item>
              <vs-collapse-item>
                <div slot="header" class="flex items-center gap-2 pl-0">
                  <div class="collapseIconBackGround pt-1 pr-2 pl-1">
                    <img
                      src="../../assets/images/svg/iconCarCollision1.svg"
                      alt="Ícone pane elétrica"
                    />
                  </div>
                  <span>Pane elétrica e mecânica</span>
                </div>
                Evite estresse desnecessário, escolha a Bem Protege e garanta
                sua tranquilidade
              </vs-collapse-item>
              <transition name="slide">
                <div v-show="verMaisBeneficios">
                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-2 pr-2 pl-2">
                        <img
                          src="../../assets/images/svg/iconAuction.svg"
                          alt="Ícone leilão."
                        />
                      </div>
                      <span>Veículos de leilão</span>
                    </div>
                    As empresas de seguro veicular não aceitam veículos de
                    leilão, mas a Bem Protege sim!
                  </vs-collapse-item>
                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-2 pr-2 pl-2 pb-1">
                        <img
                          src="../../assets/images/svg/iconBackupCar.svg"
                          alt="Ícone pane elétrica"
                        />
                      </div>
                      <span>Carro reserva</span>
                    </div>
                    Nossa cobertura de carro reserva garante sua mobilidade com
                    as opções de 15 ou 30 dias
                  </vs-collapse-item>
                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-3 pr-3 pl-3">
                        <img
                          src="../../assets/images/svg/iconFlashlight.svg"
                          alt="Ícone Fenômenos da natureza."
                        />
                      </div>
                      <span>Fenômenos da natureza</span>
                    </div>
                    A Bem Protege deixa você protegido contra tempestades,
                    chuvas de granizo, alagamentos e mais
                  </vs-collapse-item>
                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-2 pr-3 pl-3">
                        <img
                          src="../../assets/images/svg/iconPersonAPP.svg"
                          alt="Ícone APP acidente pessoal."
                        />
                      </div>
                      <span>AP/APP Acidente pessoal</span>
                    </div>
                    Em caso de acidente com lesão, fratura ou morte, a Bem
                    Protege assegura o suporte para beneficiário em até R$
                    10.000
                  </vs-collapse-item>

                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-2 pr-2 pl-2">
                        <img
                          src="../../assets/images/svg/iconTire.svg"
                          alt="Ícone Trocas de pneus."
                        />
                      </div>
                      <span>Trocas de pneus</span>
                    </div>
                    Evite acidentes, o BP Truck te assiste em casos de troca de
                    pneus de caminhões, carretas e implementos.
                  </vs-collapse-item>
                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-2 pr-2 pl-2 pb-1">
                        <img
                          src="../../assets/images/svg/iconKeys.svg"
                          alt="Ícone serviço de chaveiro."
                        />
                      </div>
                      <span>Serviço de chaveiro</span>
                    </div>
                    Nossa cobertura oferece serviço de chaveiro para uso reserva
                    e problemas relacionados às travas das portas
                  </vs-collapse-item>
                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-2 pr-3 pl-3">
                        <img
                          src="../../assets/images/svg/iconHotel.svg"
                          alt="Ícone hospedagem emergencial."
                        />
                      </div>
                      <span>Hospedagem emergencial</span>
                    </div>
                    Em caso de acidentes, nossos beneficiários contam com o
                    benefício de hospedagem emergencial
                  </vs-collapse-item>
                  <vs-collapse-item>
                    <div slot="header" class="flex items-center gap-2 pl-0">
                      <div class="collapseIconBackGround pt-2 pr-2 pl-1 pb-1">
                        <img
                          src="../../assets/images/svg/iconWindshield.svg"
                          alt="Ícone Cobertura para vidro, para-brisa e faróis."
                        />
                      </div>
                      <span>Cobertura para vidro, para-brisa e faróis</span>
                    </div>
                    Você não precisa mais se preocupar com os custos de reparos
                    de vidros, para-brisas e faróis. A Bem Protege cobre todos
                    esses imprevistos!
                  </vs-collapse-item>
                </div>
              </transition>
            </vs-collapse>
            <div
              class="botaoVerMaisBeneficios flex gap-2 justify-center items-center p-5"
              @click="alternaVisualizarBeneficios()"
            >
              <span
                >Ver
                {{ rotacionaIconSetaVerMaisBeneficios ? 'menos' : 'mais' }}
                benefícios</span
              ><i
                class="vs-icon icon-scale feather icon-chevron-down null"
                :class="{
                  iconeSetaParaCimaTransform:
                    rotacionaIconSetaVerMaisBeneficios,
                  iconeSetaParaBaixoTransform:
                    !rotacionaIconSetaVerMaisBeneficios,
                }"
                :style="{
                  transform: rotacionaIconSetaVerMaisBeneficios
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                }"
              />
            </div>
            <!--  END LANDING PAGE BLOCO COLLAPSE BENEFÍCIOS -->
            <!--  START LANDING PAGE BLOCO EXPLICATIVO -->
            <div class="hidden lg:block">
              <div class="flex justify-center pt-10 pb-5">
                <img
                  src="../../assets/images/elements/fala-comigo-bb-lg.png"
                  alt="# Fala comigo BB!"
                />
              </div>
              <div class="text-center pt-5 pb-5">
                <span class="textoEmbaixadorCinza">
                  Faça parte da bem protege <br />e deixe
                  <b>se veículo assistido 24 horas por dia</b>
                </span>
              </div>
            </div>
          </div>

          <div class="mt-5 flex justify-center items-end">
            <img
              src="../../assets/images/fotos-gustavo-lima/gustavo-lima-mostrando-logo.png"
              alt=""
            />
          </div>
          <div
            class="cardAzul flex items-center flex-col p-5 lg:bg-white lg:pt-0"
          >
            <div class="lg:hidden">
              <div class="flex justify-center pt-5">
                <img
                  src="../../assets/images/elements/fala-comigo-bb.png"
                  alt="# Fala comigo BB!"
                />
              </div>
              <div class="text-center pt-5 pb-5">
                <span class="textoEmbaixadorCinza">
                  Faça como o Embaixador, proteja o seu veículo com a
                  <b>Bem Protege 24 horas por dia.</b>
                </span>
              </div>
            </div>
            <div class="flex items-center flex-col w-full lg:flex-row lg:gap-5">
              <div class="cardAzulInterno p-5 mb-5 w-full">
                <div class="flex items-center flex-col">
                  <div>
                    <img
                      src="../../assets/images/svg/iconSmile.svg"
                      alt="Ícone smile."
                    />
                  </div>
                  <div>
                    <span class="tituloCardSecundario"
                      >Experiência simplificada</span
                    >
                  </div>
                  <div class="subtituloCardSecundario">
                    <span>Menos burocracia na hora de contratar.</span>
                  </div>
                </div>
              </div>
              <div class="cardAzulInterno p-5 mb-5 w-full">
                <div class="flex items-center flex-col">
                  <div>
                    <img
                      src="../../assets/images/svg/iconEyeOpen.svg"
                      alt="Ícone olho."
                    />
                  </div>
                  <div>
                    <span class="tituloCardSecundario text-center"
                      >Nada de pegadinhas</span
                    >
                  </div>
                  <div class="subtituloCardSecundario text-center">
                    <span>Você sabe exatamente o que está contratando.</span>
                  </div>
                </div>
              </div>
              <div class="cardAzulInterno p-5 mb-5 w-full">
                <div class="flex items-center flex-col">
                  <div>
                    <img
                      src="../../assets/images/svg/iconStar.svg"
                      alt="Ícone estrela."
                    />
                  </div>
                  <div>
                    <span class="tituloCardSecundario text-center"
                      >Satisfação dos clientes</span
                    >
                  </div>
                  <div class="subtituloCardSecundario text-center">
                    <span>Mais de 200 mil beneficiários satisfeitos.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="div-button w-full mb-3 lg:pt-10 lg:w-auto">
              <div
                class="botaoContratarAgora flex justify-center p-5 gap-2 lg:pr-12 lg:pl-12"
                @click="modalNovaProposta = true"
              >
                <span>Gerar proposta</span>
                <img
                  src="../../assets/images/svg/iconArrowRight.svg"
                  alt="Ícone Escudo"
                />
              </div>
            </div>
            <div
              class="textoEmbaixadorCinza hidden lg:block text-center lg:pb-10"
            >
              <span>Proposta fácil, rápida e <b>segura </b></span>
            </div>
          </div>
        </div>
        <!--  END LANDING PAGE BLOCO SWIPPER TIPOS DE PROTEÇÃO -->

        <!--  START LANDING PAGE BLOCO SWIPPER DEPOIMENTOS -->
        <div class="bgAzulSuperiorLg lg:pt-5" ref="blocoDepoimentos">
          <div class="container">
            <div class="protecaoCompleta p-5 text-center">
              <span
                >Elogios dos nossos <br />
                beneficiários 😍</span
              >
            </div>
            <div class="swipperServicos pb-5 pt-5 lg:pt-0">
              <swiper :options="swiperOption1" class="p-5">
                <swiper-slide class="pb-5">
                  <div class="cardSwiperClientes p-5 mt-5 flex lg:p-8">
                    <div>
                      <div class="flex justify-start gap-3">
                        <div>
                          <img
                            src="../../assets/images/portrait/small/perfil10.png"
                            alt="Foto de perfil cliente."
                          />
                        </div>
                        <div>
                          <div class="nomeClienteCardDepoimento">
                            <span>Lívia Mendes</span>
                          </div>
                          <div>
                            <img
                              src="../../assets/images/svg/iconCheckMark1.svg"
                              alt="ícone check."
                            />
                            <span class="ml-1">Reebolso pago</span>
                          </div>
                        </div>
                      </div>
                      <div class="depoimentoCardDepoimento pt-4">
                        <span>
                          Só tenho oque agradecer, meu esposo sofreu um acidente
                          onde o carro deu pt de imediato acionamos,
                          apresentamos toda a documentação necessária até mesmo
                          porque meu esposo não estava errado e depois de tudo
                          enviado e conferido, após a baixa do gravame porque
                          meu carro ainda faltava algumas parcelas pra ser
                          quitado, a bem protege pagou certinho o valor da
                          tabela FIPE do meu carro.
                        </span>
                      </div>
                    </div>
                    <div class="flex items-end justify-end pl-5 lg:hidden">
                      <img
                        src="../../assets/images/svg/imgLine7.svg"
                        alt="Linha de divisão entre depoimentos."
                      />
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide class="pb-5">
                  <div class="cardSwiperClientes p-5 mt-5 flex lg:p-8">
                    <div>
                      <div class="flex justify-start gap-3">
                        <div>
                          <img
                            src="../../assets/images/portrait/small/perfil12.png"
                            alt="Foto de perfil cliente."
                          />
                        </div>
                        <div>
                          <div class="nomeClienteCardDepoimento">
                            <span>Isis Correa</span>
                          </div>
                          <div>
                            <img
                              src="../../assets/images/svg/iconCheckMark1.svg"
                              alt="ícone check."
                            />
                            <span class="ml-1">Assistência concluída</span>
                          </div>
                        </div>
                      </div>
                      <div class="depoimentoCardDepoimento pt-4">
                        <span>
                          Precisei de remoção por guincho recentemente e fomos
                          atendidos muito bem, tanto pela equipe do atendimento
                          quanto pelo guincheiro. Sempre que precisei tirar
                          alguma dúvida foi muito fácil conseguir a informação.
                          Existem vários canais de comunicação com a empresa,
                          inclusive o próprio consultor de vendas nos ajuda.
                        </span>
                      </div>
                    </div>
                    <div class="flex items-end justify-end pl-5 lg:hidden">
                      <img
                        src="../../assets/images/svg/imgLine7.svg"
                        alt="Linha de divisão entre depoimentos."
                      />
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide class="pb-5">
                  <div class="cardSwiperClientes p-5 mt-5 flex lg:p-8">
                    <div>
                      <div class="flex justify-start gap-3">
                        <div>
                          <img
                            src="../../assets/images/portrait/small/perfil13.png"
                            alt="Foto de perfil cliente."
                          />
                        </div>
                        <div>
                          <div class="nomeClienteCardDepoimento">
                            <span>Beto Jesus</span>
                          </div>
                          <div>
                            <img
                              src="../../assets/images/svg/iconCheckMark1.svg"
                              alt="ícone check."
                            />
                            <span class="ml-1">Assistência concluída</span>
                          </div>
                        </div>
                      </div>
                      <div class="depoimentoCardDepoimento pt-4">
                        <span>
                          Ótimo eu liguei pra assistência 24 horas e solicitei
                          um guincho as 6:27 da manhã as 7 horas chegou fui bem
                          atendido e recomendo pra outras pessoas não só pelo
                          guincho mas sim pela proteção veicular do meu carro
                          vcs estão de parabéns.
                        </span>
                      </div>
                    </div>
                    <div class="flex items-end justify-end pl-5 lg:hidden">
                      <img
                        src="../../assets/images/svg/imgLine7.svg"
                        alt="Linha de divisão entre depoimentos."
                      />
                    </div>
                  </div>
                </swiper-slide>
                <swiper-slide class="pb-5">
                  <div class="cardSwiperClientes p-5 mt-5 flex lg:p-8">
                    <div>
                      <div class="flex justify-start gap-3">
                        <div>
                          <img
                            src="../../assets/images/portrait/small/perfil15.png"
                            alt="Foto de perfil cliente."
                          />
                        </div>
                        <div>
                          <div class="nomeClienteCardDepoimento">
                            <span>Ney</span>
                          </div>
                          <div>
                            <img
                              src="../../assets/images/svg/iconCheckMark1.svg"
                              alt="ícone check."
                            />
                            <span class="ml-1">Assistência concluída</span>
                          </div>
                        </div>
                      </div>
                      <div class="depoimentoCardDepoimento pt-4">
                        <span>
                          Gostei do atendimento, desde o tempo para falar com a
                          atendente até o tempo de resposta do reboque que
                          chegou rápido, fez um bom transporte e finalizou o
                          serviço com excelência. Parabéns a empresa do guincho
                          e também ao profissional Eduardo pelo atendimento.
                        </span>
                      </div>
                    </div>
                    <div class="flex items-end justify-end pl-5 lg:hidden">
                      <img
                        src="../../assets/images/svg/imgLine7.svg"
                        alt="Linha de divisão entre depoimentos."
                      />
                    </div>
                  </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
        </div>
        <!--  END LANDING PAGE BLOCO SWIPPER DEPOIMENTOS -->

        <!--  START LANDING PAGE BLOCO MAPA -->
        <div class="container">
          <div
            class="cardAzul flex items-center flex-col p-5 lg:flex-row-reverse lg:gap-16 lg:justify-center lg:bg-white lg:pt-10"
          >
            <div class="flex flex-col lg:w-1/2">
              <div class="tituloPrimeiroCardAzul text-center pb-5 lg:text-left">
                <span>Expansão Bem Protege</span>
              </div>
              <div class="flex items-start">
                <div class="collapseIconBackGround pt-2 pr-2 pb-1 pl-2 mr-4">
                  <img
                    src="../../assets/images/svg/iconWalletCheck.svg"
                    alt="Ícone maleta com símbolo de 'V'."
                  />
                </div>
                <div>
                  <div class="tituloIconeInformacoes">
                    <span>Referencia em segurança automotiva</span>
                  </div>
                  <div class="subtituloIconeInformacoes">
                    <span
                      >Somos referência nacional em segurança automotiva</span
                    >
                  </div>
                </div>
              </div>
              <vs-divider />
              <div class="flex items-start pt-2">
                <div class="collapseIconBackGround pt-2 pr-2 pb-1 pl-2 mr-4">
                  <img
                    src="../../assets/images/svg/iconMap1.svg"
                    alt="Ícone mapa."
                  />
                </div>
                <div>
                  <div class="tituloIconeInformacoes">
                    <span>Presente em 26 estados</span>
                  </div>
                  <div class="subtituloIconeInformacoes">
                    <span
                      >Uma série de benefícios para que
                      <b>você tenha tranquilidade</b> onde estiver.</span
                    >
                  </div>
                </div>
              </div>
              <vs-divider />
              <div
                class="div-button lg:w-1/2 mb-3 lg:pt-10 lg:w-auto hidden lg:block"
              >
                <div
                  class="botaoContratarAgora flex justify-center p-5 gap-2"
                  @click="modalNovaProposta = true"
                >
                  <span>Gerar proposta</span>
                  <img
                    src="../../assets/images/svg/iconArrowRight.svg"
                    alt="Ícone Escudo"
                  />
                </div>
              </div>
            </div>
            <div>
              <img
                src="../../assets/images/svg/iconMapBrasil.svg"
                alt="Mapa de pensença da Bem Protege em todo o Brasil."
                class="fotoMapaBrasil"
              />
            </div>
          </div>
        </div>
        <!--  END LANDING PAGE BLOCO MAPA -->

        <!--  START LANDING PAGE BLOCO DÚVIDAS FREQUENTES -->
        <!-- <div class="bgCinzaGeral" ref="blocoDuvidas">
          <div class="container">
            <div class="tituloPrimeiroCardAzul text-center p-5 lg:pt-10">
              <span>Dúvidas frequentes</span>
            </div>
            <vs-collapse>
              <vs-collapse-item
                v-for="duvida in duvidasFrequentes"
                :key="duvida.id"
              >
                <div slot="header" class="flex items-center gap-2 pl-0">
                  <span>{{ duvida.pergunta }}</span>
                </div>
                {{ duvida.resposta }}
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div> -->
        <!--  END LANDING PAGE BLOCO DÚVIDAS FREQUENTES -->

        <!--  START LANDING PAGE BLOCO ÚLTIMA CHAMADA -->
        <div
          class="container flex flex-col lg:flex-row-reverse lg:px-12 lg:mb-12 lg:mt-12"
        >
          <div class="flex justify-center pt-5 lg:w-1/2">
            <img
              src="../../assets/images/portrait/small/womanSmile.png"
              alt="Mulher sorrindo."
              class="fotoRodape"
            />
          </div>
          <div class="flex flex-col lg:w-1/2 lg:justify-center">
            <div class="textoInumerosBeneficios text-center p-5 lg:text-left">
              <span
                >Segurança de ponta, e com inúmeros benefícios, contrate
                agora!</span
              >
            </div>
            <div
              class="hidden lg:block textoCoberturaCompleta text-center pb-5 lg:text-left lg:pl-5"
            >
              <span
                >A Bem Protege possui uma cobertura completa a qualquer hora, em
                qualquer lugar!</span
              >
            </div>
            <div>
              <div
                class="div-button flex justify-center pt-3 pb-5 lg:justify-start lg:pl-5"
              >
                <div
                  class="botaoContratarAgora flex gap-2"
                  @click="modalNovaProposta = true"
                >
                  <span>Gerar proposta</span>
                  <img
                    src="../../assets/images/svg/iconArrowRight.svg"
                    alt="Ícone Escudo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  END LANDING PAGE BLOCO ÚLTIMA CHAMADA -->
      </div>

      <div v-else class="conteudo-form">
        <novaPropostaVue :idEmpresaProps="idEmpresaProps" :isLanding="true" />
      </div>

      <div class="text-center">
        <vs-divider />
        <div>
          <img src="../../assets/images/logo/bp-logo.png" width="150" />
        </div>
        <div class="textFooter pb-5">
          <span>2023 - Bem Protege - Todos os direitos reservados</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.min.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import novaPropostaVue from './novaProposta.vue';
import formCep from './../forms/Form-Landing-ColetaCEP.vue';

export default {
  name: 'landingPageBP',
  data() {
    return {
      idEmpresaProps: 120,
      blocosLandingPage: [
        {
          nome: 'Cobertura de ponta',
          divDestino: 'blocoInicial',
        },
        {
          nome: 'Benefícios',
          divDestino: 'blocoBeneficios',
        },
        {
          nome: 'Depoimentos',
          divDestino: 'blocoDepoimentos',
        },
      ],
      verMaisBeneficios: false,
      cepPreenchido: false,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      swiperOption1: {
        slidesPerView: 3,
        spaceBetween: 50,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      duvidasFrequentes: [
        {
          pergunta: 'O que é proteção veicular?',
          resposta:
            'Proteção veicular é um serviço para proteção de veículos que funciona por meio de associação entre proprietários de veículos sob controle de uma organização que faz a gestão. Ao assinar o contrato, o proprietário se torna um dos benficiários e passa, portanto, a fazer parte do sistema de rateio.',
        },
        {
          pergunta: 'Como funcionam as associações de proteção veicular?',
          resposta:
            'As associações de proteção veicular funcionam como um grupo de proprietários de veículos que contribuem coletivamente todos os meses para garantir a proteção do grupo por meio de um rateio. Ao se tornar beneficiário de um grupo ou uma associação deste tipo você passa a fazer parte de um sistema de rateio.',
        },
        {
          pergunta: 'Qual a diferença entre seguro e proteção veicular?',
          resposta:
            'O seguro é realizado por empresas seguradoras, que têm interesses econômicos privados, ao contrário da proteção veicular que funciona por meio de associação cooperativa sem fins lucrativos. Ou seja, pessoas se unem para dividir os custos e despesas da proteção dos veículos. Na proteção veicular, também não existe uma apólice, a documentação é substituída pelo contrato de associação. O contrato de associação é o documento legal que determina os direitos e deveres de ambas as partes. O contrato de associação especifica como os serviços serão prestados e os prazos de seu cumprimento, a fim de que você e seu patrimônio fiquem protegidos.',
        },
        {
          pergunta: 'Qual é a cobertura da proteção veicular?',
          resposta:
            'Existem diversos tipos de coberturas no mercado de proteção veicular. A Cobertura da Bem Protege Proteção Veicular é - sem dúvidas - uma das mais completas do Brasil, incluindo proteção contra furto, roubo, colisão, incêndio, assistência 24h com cobertura nacional, guincho ilimitado para sinistro, proteção de vidros e faróis, proteção para terceiros e muito mais.',
        },
        {
          pergunta: 'Proteção veicular é confiável?',
          resposta:
            'Sim! A proteção veicular é completamente legal e confiável. Não se trata de um seguro tradicional, e sim de um contrato que é feito por meio de associação a um grupo de proprietários de veículos e administrado por uma empresa. A proteção veicular é regida pelo Código Civil Brasileiro, não havendo nenhuma lei que proíba a existência de grupos de pessoas com a finalidade da Proteção Veicular. Apesar disso, é muito importante que você escolha uma associação de proteção séria e sólida no mercado. Além disso, assim como em um seguro, é importante analisar quais as coberturas estão inclusas em seu contrato de proteção veicular, o que ele cobre e em quais regiões do Brasil.',
        },
        {
          pergunta: 'Quais as vantagens da proteção veicular?',
          resposta:
            'A Proteção Veicular da Bem Protege cobre seus beneficiários em todo território nacional, com assistência 24h. A cobertura inclui roubo ou furto, colisões, incêndio, alagamento, indenização a terceiros, acidentes pessoais, carro reserva e muito mais.',
        },
        {
          pergunta: 'Qual o procedimento em caso de acidente?',
          resposta:
            'Se ocorrer algum sinistro ou outro tipo de ocorrência com o seu veículo, o indicado é que se entre em contato com a associação o quanto antes p ara que seja providenciada a indenização ou reparo do veículo. É possível informar uma ocorrência ou sinistro através do site, aplicativo do celular, e-mail ou telefone.',
        },
      ],
      divAtiva: null,
      modalNovaProposta: false,
      rotacionaIconSetaVerMaisBeneficios: false,
    };
  },
  methods: {
    alternaVisualizarBeneficios() {
      this.verMaisBeneficios = !this.verMaisBeneficios;
      this.rotacionaIconSetaVerMaisBeneficios =
        !this.rotacionaIconSetaVerMaisBeneficios;
    },
    scrollBloco(divDestino) {
      const element = this.$refs[divDestino];
      element.scrollIntoView({ behavior: 'smooth' });
      this.divAtiva = divDestino;
    },
    verificaCepPreenchido() {
      if (localStorage.getItem('estado')) {
        this.cepPreenchido = true;
      }
    },
    verificarDivVisivel() {
      for (const bloco of this.blocosLandingPage) {
        const element = this.$refs[bloco.divDestino];
        if (element) {
          const rect = element.getBoundingClientRect(); // Função do JS que retorna um obj com a posição e tamanho do elemento.
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (isVisible) {
            this.divAtiva = bloco.divDestino;
            break;
          }
        }
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.verificarDivVisivel);
    document.title = 'Bem Protege - Gerar proposta agora';
  },
  mounted() {
    window.addEventListener('scroll', this.verificarDivVisivel);
    this.verificaCepPreenchido();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.verificarDivVisivel);
  },
  components: {
    swiper,
    swiperSlide,
    novaPropostaVue,
    formCep,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Product+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
</style>

<style lang="scss" scoped>
.invoiceHeaderDiv {
  background-color: #ffffff;
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 99;
}
.div-button {
  text-align: center;
}
.botaoContratarAgora {
  background-color: #158c12;
  border-radius: 1rem;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
  padding: 0.56rem 2rem 0.56rem 2rem;
  transition: background-color 0.3s;
  font-family: 'Product Sans', sans-serif;
  cursor: pointer;
  &:active,
  &:focus {
    background-color: #0f6a0b;
  }
  i {
    margin-left: 0.44rem;
    display: flex;
    text-align: center;
    align-items: center;
  }
}
hr {
  border: none;
  height: 1px;
  background-color: #eeeeee;
  margin-top: 0.625rem;
}
.bordaAzul {
  border-bottom: 2px solid #078fcf;
}
.cardAzul {
  background: #e6f3ff;
  border-radius: 0.94rem;
}
.tituloPrimeiroCardAzul {
  font-weight: 700;
  font-size: 1.5rem;
  color: #114880;
  font-family: 'Product Sans', sans-serif;
}
.tituloPrimeiroCardAzul2 {
  font-weight: 700;
  font-size: 1.125rem;
  font-family: 'Product Sans', sans-serif;
  color: #078fcf;
}
.conteudoPrimeiroCardAzul {
  color: #114880;
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
}
.iconesDivReclameAqui {
  position: relative;
}
.iconeReclameAqui {
  position: absolute;
  right: -8px;
  top: -0.625rem;
}
.fotoGustavoLima {
  bottom: -16px;
  right: -50px;
}
.carousel-example .swiper-container .swiper-slide {
  text-align: center;
  font-size: 2.375rem;
  font-weight: 700;
  background-color: #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 300px;
}
.cardSwiper {
  border-left: 4px solid #078fcf;
  background: #ffffff;
  border-radius: 0.75rem;
  filter: drop-shadow(0px 0px 0.625rem rgba(0, 0, 0, 0.35));
}
.titleSwipper {
  color: #000000;
  font-size: 0.625rem;
  font-weight: 400;
  font-family: 'Product Sans', sans-serif;
}
.subtitleSwipper {
  color: #000000;
  font-size: 0.94rem;
  font-weight: 700;
  font-family: 'Product Sans', sans-serif;
}
.detalhesCardSwiper {
  color: #4e6c8a;
  font-size: 0.75rem;
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
}
.textoContratarAgoraSwiper {
  color: #114880;
  font-size: 0.875rem;
  font-weight: 400;
  font-family: 'Product Sans', sans-serif;
}
.subTitulosMeio {
  text-align: center;
}
.protecaoCompleta {
  color: #114880;
  font-family: 'Product Sans', sans-serif;
  font-size: 1.9rem;
  font-weight: 700;
}
.principaisBeneficios {
  color: #078fcf;
  font-family: 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
}
.collapseIconBackGround {
  background-color: #088fce;
  border-radius: 6px;
}
.vs-collapse-item--header {
  font-size: 1.2rem;
  padding: 1rem 1rem 1rem 0rem !important;
}
.vs-collapse {
  transition: all 0.3s ease;
  cursor: pointer;
  border-radius: 8px;
  padding: 0.625rem 0.625rem 0.625rem 0px;
}
.botaoVerMaisBeneficios {
  color: #078fcf;
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Roboto', sans-serif;
  cursor: pointer;
}
.textoEmbaixadorCinza {
  color: #676767;
  font-weight: 400;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
}
.cardAzulInterno {
  background: #daecff;
  font-family: 'Roboto', sans-serif;
  border-radius: 0.94rem;
}
.tituloCardSecundario {
  color: #078fcf;
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Roboto', sans-serif;
}
.subtituloCardSecundario {
  color: #4e6c8a;
  font-size: 1rem;
  font-weight: 400;
}
.nomeClienteCardDepoimento {
  font-family: 'Product Sans', sans-serif;
  color: #000000;
  font-size: 0.9rem;
  font-weight: 700;
}
.depoimentoCardDepoimento {
  font-family: 'Roboto', sans-serif;
  color: #2b2b2b;
  font-size: 0.95rem;
  font-weight: 400;
}
.tituloIconeInformacoes {
  font-family: 'Roboto', sans-serif;
  color: #114880;
  font-size: 1rem;
  font-weight: 700;
}
.subtituloIconeInformacoes {
  font-family: 'Roboto', sans-serif;
  color: #4e6c8a;
  font-size: 0.95rem;
  font-weight: 400;
}
.textoInumerosBeneficios {
  font-family: 'Roboto', sans-serif;
  color: #3e3e3e;
  font-size: 1.2rem;
  font-weight: 700;
}
.textoCoberturaCompleta {
  font-family: 'Roboto', sans-serif;
  color: #2b2b2b;
  font-size: 0.95rem;
  font-weight: 400;
}
.textFooter {
  font-family: 'Roboto', sans-serif;
  color: #3e3e3e;
  font-size: 0.75rem;
  font-weight: 400;
}
@media (min-width: 992px) {
  .bgAzulSuperiorLg {
    background: #e6f3ff;
  }
  .tituloPrimeiroCardAzul,
  .tituloPrimeiroCardAzul2 {
    font-size: 2.5rem;
  }
  .fotoGustavoLimaLg {
    bottom: 0;
  }
  .cardSwiper {
    height: 270px;
    width: 260px;
  }
  .cardSwiperClientes {
    background: white;
    border-radius: 1.1rem;
    height: 320px;
    width: 320px;
    filter: drop-shadow(0px 0px 0.625rem rgba(142, 187, 255, 0.507));
  }
  .textoEmbaixadorCinza {
    font-size: 1.3rem;
  }
  .textoInumerosBeneficios {
    font-family: 'Product Sans', sans-serif;
    color: #114880;
    font-size: 2rem;
    font-weight: 700;
  }
  .bgCinzaGeral {
    background: #f6f6f6;
  }
  .fotoRodape {
    height: 300px;
  }
  .fotoMapaBrasil {
    height: 400px;
  }
}
</style>
<style>
#modalNovaProposta.con-vs-popup .vs-popup {
  min-width: 70%;
}
</style>
